import React from "react";
import { AttributePairRow } from "./attribute-pair-row";

export const NewAttributeRow = ({
    attributesPair,
    removeAttribute,
    readOnlyOverride,
    references,
    columnWidths,
    isReadOnlyAdd,
    isReadOnlyEdit,
    isReadOnlyDelete,
    isCompleted,
    isBrandVerified,
}) => {
    return (
        <AttributePairRow
            columnWidths={columnWidths}
            attributesPair={attributesPair}
            removeAttribute={removeAttribute}
            readOnlyOverride={readOnlyOverride}
            references={references}
            isReadOnlyAdd={isReadOnlyAdd}
            isReadOnlyEdit={isReadOnlyEdit}
            isReadOnlyDelete={isReadOnlyDelete}
            isCompleted={isCompleted}
            isBrandVerified={isBrandVerified}
        />
    );
};
